import React from 'react';

import { AnnouncementsManagerTab } from '../../routes/announcementsManager/announcementsManagerPages';
import { AnnouncementPublishTab } from '../../pages/Announcements/components/Announcements/utils';
import { DEFAULT_ANNOUNCEMENT_DATE_RANGE } from '../../pages/Announcements/feedUtils';
import { ALL_COMMUNITIES_FILTER } from '../../utils/announcement';

const allPodsOption = {
  label: 'All Pods',
  value: 'ALL',
};

const allCommunitiesOption = {
  label: 'All communities',
  value: ALL_COMMUNITIES_FILTER,
};

const initialValues = {
  announcementCollection: { docs: [] },
  isReady: false,
  selectedAnnouncement: null,
  selectedAnnouncementCommentsCollection: { docs: [] },
  selectedAnnouncementComments: [],
  selectedCommentId: null,
  isCommentsReady: false,
  coachCommentsCollection: { docs: [] },
  coachUnreadComments: [],
  commentReportsCollection: { docs: [] },
  commentReports: [],
  notificationCount: {
    [AnnouncementsManagerTab.REPORTS]: 0,
    [AnnouncementsManagerTab.NOTIFICATIONS]: 0,
  },
  isLoading: false,
  showResolvedReports: false,
  isPostsReady: false,
  podFilterOptions: {},
  showPodFilter: false,
  selectedPodFilterId: allPodsOption.value,
  setSelectedPodFilterId: () => {},
  filteredComments: [],
  isPinConfirmOpen: false,
  currentPinnedAnnouncement: null,
  handlePinRequest: () => {},
  handleUnpinRequest: () => {},
  confirmPinReplace: () => {},
  cancelPinReplace: () => {},
  selectedPublishTab: AnnouncementPublishTab.PUBLISHED,
  setSelectedPublishTab: () => {},
  scheduledAnnouncementCollection: { docs: [] },
  scheduledCount: 0,
  selectedDateRange: DEFAULT_ANNOUNCEMENT_DATE_RANGE,
  setSelectedDateRange: () => {},
  isLoadingPosts: false,
  updateCommentAndAnnouncementStateById: () => {},
  communities: [],
  selectedCommunityFilter: allCommunitiesOption.value,
  setSelectedCommunityFilter: () => {},
  hidePinnedPosts: false,
  setHidePinnedPosts: () => {},
  showCoachPostsOnly: false,
  setShowCoachPostsOnly: () => {},
  selectedGroupSiblings: [],
  selectedSiblingId: null,
  selectGroupSibling: () => {},
  isSiblingSwitching: false,
};

const AnnouncementContext = React.createContext(initialValues);

export default AnnouncementContext;
export {
  initialValues,
  allPodsOption,
  allCommunitiesOption,
  ALL_COMMUNITIES_FILTER,
};
